import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17,21H7a2,2,0,0,1-2-2V11A2,2,0,0,1,7,9H17a2,2,0,0,1,2,2v8A2,2,0,0,1,17,21Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,17.09V14.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.53,13.22a.75.75,0,1,1-1.061,0,.75.75,0,0,1,1.061,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8,9V7H8a4,4,0,0,1,4-4h0a4,4,0,0,1,4,4h0V9"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgLock;
